import React from 'react'
import { useMediaQuery } from 'react-responsive'

export type MediaQueryProps<T extends keyof UseMediaArgs> = Record<T, boolean>

type UseMediaQueryType = typeof useMediaQuery

export type UseMediaArgs = Record<string, Parameters<UseMediaQueryType>>

const WithMediaQuery =
	(args: UseMediaArgs) =>
	<P extends Record<string, any>>(Component: React.ComponentType<P>) =>
	(props: P) => {
		const mediaQueries = Object.keys(args)
			.map(key => ({
				[key]: useMediaQuery(...args[key]),
			}))
			.reduce(
				(acc, current) => ({
					...acc,
					...current,
				}),
				{},
			)

		return <Component {...mediaQueries} {...props} />
	}

export default WithMediaQuery
